var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-item",class:{ 'non-clickable': _vm.isNonClickable },style:(_vm.style)},[_c('PlaylistPlayer',{style:(_vm.playerStyle),attrs:{"playlist":Object.assign(_vm.widget.object, {
        imageMode: _vm.widget.object.imageMode || _vm.widget.position.imageMode,
      }),"assocId":_vm.widget.assoc_id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }